import React, { memo, ReactNode } from 'react';
import { getMergedClassNames } from '../../../../utils/HTMLutils';
import Collapse from '../../../collapse/Collapse';
import DropdownMenu, {
  DropdownMenuProps,
} from '../../../dropdownMenu/DropdownMenu';
import Row from '../../../row/Row';
import './TableUpperHeader.scss';
const rootClassName = 'component-upper-header-table';

interface upperHeaderButtonType {
  type: 'Button';
  id?: string;
  onClick?: () => void;
  label?: string;
  leftIcon?: JSX.Element | React.ReactNode;
  rightIcon?: JSX.Element | React.ReactNode;
  disabled?: boolean;
}

export interface upperHeaderDropdownMenuType
  extends Omit<DropdownMenuProps, 'children'> {
  type: 'DropdownMenu';
  children: upperHeaderButtonType;
}

export interface TableUpperHeaderProps {
  active?: boolean;
  leftContent?: (upperHeaderButtonType | upperHeaderDropdownMenuType)[];
  rightContent?: (upperHeaderButtonType | upperHeaderDropdownMenuType)[];
  opened?: boolean;
  collapsedContent?: ReactNode;
  // buttons?: {
  //   id?: string;
  //   disabled?: boolean;
  //   icon?: React.ReactNode;
  //   label?: string;
  //   onClick?: () => void;
  // }[];
}

function TableUpperHeader(props: TableUpperHeaderProps) {
  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        props.active ? 'active' : '',
      ])}
    >
      <div className={`${rootClassName}-left`}>
        {props.leftContent?.map((btn, i) => {
          return btn.type === 'Button' ? (
            <button
              key={i}
              id={btn.id}
              onClick={btn.onClick}
              disabled={!props.active || btn?.disabled || false}
              className={`${rootClassName}-btn`}
              type='button'
            >
              {btn.leftIcon && <span>{btn.leftIcon}</span>}
              {btn.label}
              {btn.rightIcon && <span>{btn.rightIcon}</span>}
            </button>
          ) : (
            <DropdownMenu {...btn} key={i}>
              <button
                key={i}
                id={btn.children.id}
                onClick={btn.children.onClick}
                className={`${rootClassName}-btn`}
                disabled={!props.active || btn?.children.disabled || false}
                type='button'
              >
                {btn.children.leftIcon && <span>{btn.children.leftIcon}</span>}
                {btn.children.label}
                {btn.children.rightIcon && (
                  <span>{btn.children.rightIcon}</span>
                )}
              </button>
            </DropdownMenu>
          );
        })}
      </div>
      <div className={`${rootClassName}-right`}>
        {props.rightContent?.map((btn, i) => {
          return btn.type === 'Button' ? (
            <button
              key={i}
              id={btn.id}
              onClick={btn.onClick}
              disabled={!props.active || btn?.disabled || false}
              className={`${rootClassName}-btn`}
              type='button'
            >
              {btn.leftIcon && <span>{btn.leftIcon}</span>}
              {btn.label}
              {btn.rightIcon && <span>{btn.rightIcon}</span>}
            </button>
          ) : (
            <DropdownMenu {...btn} key={`children_${i}`}>
              <button
                key={i}
                id={btn.children.id}
                onClick={btn.children.onClick}
                disabled={!props.active || btn?.children.disabled || false}
                className={`${rootClassName}-btn`}
                type='button'
              >
                {btn.children.leftIcon && <span>{btn.children.leftIcon}</span>}
                {btn.children.label}
                {btn.children.rightIcon && (
                  <span>{btn.children.rightIcon}</span>
                )}
              </button>
            </DropdownMenu>
          );
        })}
      </div>
      {props.collapsedContent ? (
        <Collapse opened={props.opened} animateOpacity>
          <Row className={`${rootClassName}-collapsed`}>
            {props.collapsedContent}
          </Row>
        </Collapse>
      ) : undefined}
    </div>
  );
}

export default memo(TableUpperHeader);
